import { render, staticRenderFns } from "./ShopsListItem.vue?vue&type=template&id=601e5b6e&"
import script from "./ShopsListItem.vue?vue&type=script&lang=js&"
export * from "./ShopsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ShopsListItem.vue?vue&type=style&index=0&id=601e5b6e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports